var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m22.28 12.825-4.076-7.251H14.66l6.072 10.331L18.674 20h3.178l7.192-14.426h-3.44l-3.325 7.25Zm22.99-7.251h-3.607l-3.05 4.678-3.03-4.678h-3.71l4.824 7.089L31.668 20h3.606l3.257-4.946L41.766 20h3.71l-5.029-7.378 4.823-7.048ZM48.81 8.5h4.39V20h3.173V8.5h4.39V5.574H48.811V8.5ZM6.682 17.133H3.176v-3.547h3.486c1.505 0 2.227.598 2.227 1.712 0 1.257-.722 1.835-2.207 1.835Zm.31-6.187H3.175V8.43h8.096V5.563H0V20h6.682c3.341 0 5.383-1.63 5.383-4.579 0-2.701-1.815-4.475-5.074-4.475ZM0 2.866h11.272V0H0v2.867Zm68.244 11.095 1.916-4.678 1.917 4.678h-3.833Zm3.42-8.49H68.74L62.556 20h3.235l1.32-3.236h6.1L74.528 20h3.318L71.665 5.47Z",
    fill: "#fff"
  })));
};

export default SvgLogo;